import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { Grid, Link, Box as MuiBox, Typography } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ComplianceCard from 'src/components/Compliance/ComplianceCard';
import { UpdateApplicationRoute } from 'src/redux/actions/Application';
import LossOfUseIcon from '../../assets/images/LossOfUse.png';
import PersonalLiabilityIcon from '../../assets/images/PersonalLiability.png';

const cards = [
  {
    key: '1',
    img: LossOfUseIcon,
    text: 'I need to purchase Renters Insurance.',
    linkText: 'Purchase a Policy',
    navigateTo: '',
    bgColor: 'background.default',
  },
  {
    key: '2',
    img: PersonalLiabilityIcon,
    text: 'I have Renters Insurance and need to submit proof to my landlord.',
    linkText: 'Verify my Policy',
    navigateTo: '',
    bgColor: 'background.secondary',
  },
];


export const ComplianceWelcome: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const nextPage = (url: string) => {
    dispatch(UpdateApplicationRoute(url));
    history.push({
      pathname: url,
      state: { detail: 'compliance' },
    })
  }

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        marginTop={10}
      >
        <MuiBox paddingX={{ xs: 5, xl: 30 }} maxWidth={1200}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={7}
            direction="column"
          >
            <Grid item textAlign="center">
              <Typography
                variant="h2"
                fontFamily="Ivar Display"
              >
                Hi, we’re TheGuarantors!
              </Typography>
            </Grid>
            <Grid item textAlign="center">
              <Typography variant="h4">How can we help you?</Typography>
              <Typography variant="body1">
                Please select the option below that best fits your needs.
              </Typography>
            </Grid>
            <Grid item>
              <Grid container justifyContent="center" alignItems="stretch">
                {cards.map((card) => {
                  return (
                    <ComplianceCard
                      bgColor={card.bgColor}
                      onClick={() =>
                        card.key === '1'
                          ? nextPage('/start-application')
                          : nextPage('/compliance')
                      }
                      icon={card.img}
                      title={card.text}
                      linkText={card.linkText}
                    />
                  );
                })}
              </Grid>
            </Grid>
            <Grid item display="flex" alignItems="center">
              <HelpOutlineRoundedIcon />
              <Typography variant="body1" marginLeft={1}>
                Have questions about Renters Insurance? Click{' '}
                <Link href="/learn" style={{color: 'inherit'}}>here</Link> to learn more.
              </Typography>
            </Grid>
          </Grid>
        </MuiBox>
      </Grid>
    </>
  );
};
